import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { useContext } from "react";
import CustomCollapse from "../../../Utilities/CustomCollapse";
import { SessionContext } from "../../../Contexts/SessionContext";
import DaysOfWeek from "../PrimaryFiltering/DaysOfWeek";
import { SecondaryFilterTickBox } from "../SecondaryFiltering/SecondaryFilterTickbox";

interface IProps {
    readOnly?: boolean;
}

export default function MainSummary({ readOnly = true }: IProps) {
    const { sessionState } = useContext(SessionContext);

    return (
        <Grid container size={12}>
            <Grid container component={Paper} size={12}>
                <Grid size={6}>
                    <b>Selected Param Range -</b> {sessionState.primaryFilters.minHeader} to {sessionState.primaryFilters.maxHeader}
                </Grid>
                <Grid size={6}>
                    <b>Actual Trip Rate Range -</b> {sessionState.primaryFilters.actualMinHeader} to {sessionState.primaryFilters.actualMaxHeader}
                </Grid>
            </Grid>
            <CustomCollapse title="Trip Rate Parameters">
                <Grid container>
                    <Grid size={6}><DaysOfWeek disabled={readOnly} /></Grid>
                </Grid>
            </CustomCollapse>
            <CustomCollapse title="Site Characteristics">
                <Grid container>
                    <Grid container size={6}>
                        <SecondaryFilterTickBox
                            title="Location Types"
                            heading="Location"
                            fetchAction="GetMainLocationTypes"
                            path="primaryFilters.locationTypes"
                            id="locationId"
                            isCompressedSummary={true}
                            disabled={readOnly}
                        />
                        <SecondaryFilterTickBox title={'PTAL Rating'} heading={'Class Code'} fetchAction={'GetPtalRating'} path={'secondaryFilters.ptalRating'} id='ptal' isCompressedSummary={true} disabled={readOnly} />
                    </Grid>
                    <Grid container size={6}>
                        <SecondaryFilterTickBox
                            title="Sub Categories"
                            heading="Sub Location"
                            fetchAction="GetSubLocationTypes"
                            path="primaryFilters.subLocationTypes"
                            id="subLocationId"
                            isCompressedSummary={true}
                            disabled={readOnly}
                        />
                        <SecondaryFilterTickBox title={'Use Class'} heading={'Class Code'} fetchAction={'GetSecondaryUseClass'} path={'secondaryFilters.useClasses'} id={'useClass'} canCollapseZeroCounts isCompressedSummary={true} disabled={readOnly} />
                        <SecondaryFilterTickBox title={'Travel Plan'} heading={'Travel Plan'} fetchAction={'GetTravelPlan'} path={'secondaryFilters.travelPlan'} id={'travelPlan'} isCompressedSummary={true} disabled={readOnly} />
                    </Grid>
                </Grid>
            </CustomCollapse>
            <CustomCollapse title="Population Summary">
                <Grid container>
                    <Grid size={6}>
                        <SecondaryFilterTickBox title={'Population < 1 Mile'} heading={'Population < 1 Mile'} fetchAction={'GetPopulationOneMile'} path={'secondaryFilters.populationOneMile'} id={'pop1MileId'} isCompressedSummary={true} disabled={readOnly} />
                    </Grid>
                    <Grid size={6}>
                        <SecondaryFilterTickBox title={'Population < 5 Miles'} heading={'Population Within 5 Miles'} fetchAction={'GetPopulationFiveMile'} path={'secondaryFilters.populationFiveMile'} id='pop5MileId' isCompressedSummary={true} disabled={readOnly} />
                    </Grid>
                    <Grid size={6}>
                        <SecondaryFilterTickBox title={'Car Ownership < 5 Miles'} heading={'Car Ownership < 5 Miles'} fetchAction={'GetCarOwnershipFiveMile'} path={'secondaryFilters.carOwnership'} id='car5Id' isCompressedSummary={true} disabled={readOnly} />
                    </Grid>
                </Grid>
            </CustomCollapse>
        </Grid>
    );
}
